export const patientPharmaciesQueryKey = (patientId?: string) =>
  patientId
    ? (["getPatientPharmacies", patientId] as const)
    : (["getPatientPharmacies"] as const);
